// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"102":"3f9cf419","342":"1d23ee86","416":"93b290b2","453":"cf456531","841":"73ccdf9c","976":"70170e57"}[chunkId] + ".chunk.js";
};